import * as React from 'react';

import { fetchNewbuildingRecommendations } from '../../slices';
import { useAppDispatch, useAppSelector as useSelector } from '../../types';

import { selectNewbuildingRecommendationsStatus, selectNewbuildingRecommendations } from '../../selectors/newbuildings';
import {
  onCardClickAnalytic,
  onRecommendationsSectionShowAnalytic,
  onShowAllClickAnalytic,
} from './analytics/analytic';
import { useDeviceType } from '@cian/ui-kit';

export const useNewbuildingRecommendations = () => {
  const dispatch = useAppDispatch();
  const deviceType = useDeviceType();
  const siteType = deviceType === 'phone' ? 'mobile' : deviceType;
  const recommendations = useSelector(selectNewbuildingRecommendations);
  const recommendationsStatus = useSelector(selectNewbuildingRecommendationsStatus);

  const onRecommendationsShow = React.useCallback(() => {
    const products = recommendations.recommendations.map((item, idx) => ({ id: item.id, position: idx }));
    onRecommendationsSectionShowAnalytic(products, siteType);
  }, [recommendations, siteType]);

  const onShowAllClick = React.useCallback(() => {
    onShowAllClickAnalytic(siteType);
  }, [siteType]);

  const onCardClick = React.useCallback(
    ({ newbuildingId, position }: { newbuildingId: number; position: number }) =>
      () => {
        onCardClickAnalytic({ newbuildingId, position, siteType });
      },
    [siteType],
  );

  React.useEffect(() => {
    dispatch(fetchNewbuildingRecommendations());
  }, [dispatch]);

  return React.useMemo(
    () => ({
      newbuildings: recommendations,
      onRecommendationsShow,
      onCardClick,
      onShowAllClick,
      recommendationsStatus,
    }),
    [recommendations, onRecommendationsShow, onCardClick, onShowAllClick, recommendationsStatus],
  );
};
